<template>
  <div
    ref="providerIcon"
    v-bind="styleList"
    class="m-provider-icon"
    :class="{'_is-svg': isSvg }"
  >
    <div
      v-if="isSvg"
      ref="svgContainer"
      class="svg-container"
    >
      <MIcon
        ref="svgElement"
        class="hidden-svg"
        :icon="icon"
      />
    </div>

    <img
      :src="iconUrl"
      class="m-provider-icon-image"
      alt="Icon"
    >
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon.vue';
  import generateLink from 'utils/common/generateLink';

  export default {
    name: 'MProviderIcon',
    components: {MIcon},
    props: {
      icon: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        isCalculateProcess: true,
        iconWidth: 0,
        iconHeight: 0
      };
    },
    computed: {
      isSvg () {
        return this.icon?.url.includes('.svg') ?? false;
      },

      iconUrl () {
        // provide package version as query param to prevent loading from cache

        // eslint-disable-next-line no-undef
        const libVersion = LIB_VERSION;
        const [svgUrl, spriteAnchor] = this.icon.url.split('#');

        return generateLink(`${svgUrl}?v=${libVersion}#${spriteAnchor}`);
      },

      styleList () {
        if (!this.isSvg || this.isCalculateProcess) {
          return {};
        }

        return {
          style: {
            width: this.iconWidth,
            height: this.iconHeight
          }
        };
      }
    },
    mounted () {
      if (this.isSvg) {
        this.$nextTick(() => setTimeout(this.updateIconSize));
      }
    },
    methods: {
      updateIconSize (tryCount = 0) {
        if (this._isDestroyed) {
          return;
        }

        tryCount = tryCount + 1;
        if (tryCount > 10) {
          console.warn('[MProviderIcon]: after 10 unsuccessful attempts to calculate the size of the content, the function shuts down');
          return;
        }

        this.isCalculateProcess = true;

        try {
          const providerIcon = this.$refs.providerIcon;

          if (!providerIcon) {
            throw new Error('The root element cannot be determined.');
          }

          const providerComputedStyle = window.getComputedStyle(providerIcon);

          if (providerComputedStyle.height && providerComputedStyle.height !== '0px') {
            this.iconHeight = `${parseFloat(providerComputedStyle.height)}px`;
          } else {
            this.iconHeight = '100%';
          }

          if (providerComputedStyle.width && providerComputedStyle.width !== '0px') {
            this.iconWidth = `${parseFloat(providerComputedStyle.width)}px`;
            this.isCalculateProcess = false;
            return;
          }

          this.$nextTick(() => setTimeout(() => {
            if (!this.$refs.svgElement) {
              throw new Error('The SVG element cannot be determined.');
            }

            const svgElement = this.$refs.svgElement.$el;
            const width = parseFloat(window.getComputedStyle(svgElement)?.width);

            if (!isNaN(width) && width > 0) {
              this.iconWidth = `${width}px`;
            } else {
              throw new Error('Unable to determine the width of the SVG element');
            }
          }));
        } catch (e) {
          this.$nextTick(() => setTimeout(() => this.updateIconSize(tryCount), 300));
          console.warn(`[MProviderIcon]: ${e}. Trying again...`);
        }

        this.isCalculateProcess = false;
      }
    }
  };
</script>

<style>
  .m-provider-icon {
    position: relative;

    &._is-svg {
      & .m-provider-icon-image {
        overflow: visible;

        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
      }
    }
  }

  .hidden-svg {
    position: absolute;

    width: auto;
    height: 100%;

    visibility: hidden;
  }

  .svg-container {
    overflow: hidden;
    height: 0;
  }
</style>
